import { HomeMainCompProps } from "../../../components/home-main-comp/home-main.comp";
import coverImage from "../../../assets/images/covers/mini/as-dev.png";

/* ICONS */
import angularIco from "../../../assets/icons/skills/angular.png";
import reactIco from "../../../assets/icons/skills/react.png";
import bootstrapIco from "../../../assets/icons/skills/bootstrap-4.png";
import jsIco from "../../../assets/icons/skills/logo-javascript.png";
import ionicIco from "../../../assets/icons/skills/ionic-icon-svgrepo-com.png";
import ngrxIco from "../../../assets/icons/skills/ngrx.png";
import reduxIco from "../../../assets/icons/skills/redux.png";
import nodeJsIco from "../../../assets/icons/skills/nodejs-icon.png";
import restIco from "../../../assets/icons/skills/api-svgrepo-com.png";
import firebaseIco from "../../../assets/icons/skills/firebase-1.png";
import nestIco from "../../../assets/icons/skills/nestjs.png";
import tsIco from "../../../assets/icons/skills/typescript.png";
import mongoIco from "../../../assets/icons/skills/mongodb-icon-1.png";
import mySqlIco from "../../../assets/icons/skills/mysql.png";
import sqLiteIco from "../../../assets/icons/skills/sqlite.png";
import oracleIco from "../../../assets/icons/skills/oracle-corporation-logo.png";
import canvasJSIco from "../../../assets/icons/skills/chart.png";
import pythonIco from "../../../assets/icons/skills/python-5.png";
import phpIco from "../../../assets/icons/skills/php-1.png";
import javaIco from "../../../assets/icons/skills/java-14.png";

/* ENGLISH */
export const developerCompEnglishData: HomeMainCompProps = {
  homeMainCompData: {
    label: "developer",
    title: "DEVELOPER",
    subtitle: "My skills as",
    img: coverImage,
    text: "My preferred technologies are <split/>MEAN<split/> and <split/>MERN",
    button: [],
    imgList: [],

    children: (
      <>
        <div className="skill-list">
          {/* Frontend */}
          <div className="skill-item">
            <ul className="skill-item-list">
              <li>
                <i>
                  <img alt="image" src={angularIco} />
                </i>{" "}
                Angular + Ngrx{" "}
                <i>
                  <img
                    alt="image"
                    src={ngrxIco}
                    style={{
                      filter: "contrast(90%) saturate(75%) brightness(130%)",
                    }}
                  />
                </i>
              </li>
              <li>
                <i>
                  <img alt="image" src={reactIco} />
                </i>{" "}
                React + Redux{" "}
                <i>
                  <img
                    alt="image"
                    src={reduxIco}
                    style={{
                      filter: "contrast(80%) saturate(155%)",
                    }}
                  />
                </i>
              </li>
              <li>
                <i>
                  <img
                    alt="image"
                    src={bootstrapIco}
                    style={{
                      filter: "contrast(80%) saturate(355%) brightness(120%)",
                    }}
                  />
                </i>{" "}
                Bootstrap
              </li>
              <li>
                <i>
                  <img alt="image" src={ionicIco} />
                </i>{" "}
                Ionic
              </li>
              <li>
                <i>
                  <img
                    alt="image"
                    src={jsIco}
                    style={{ filter: "saturate(120%)" }}
                  />
                </i>{" "}
                Javascript
              </li>
            </ul>
            <footer className="skill-item-title">
              Frontend <span style={{ color: "#6d78ad" }}>33.3%</span>{" "}
            </footer>
          </div>

          {/* Backend */}
          <div className="skill-item">
            <ul className="skill-item-list">
              <li>
                <i>
                  <img alt="image" src={nodeJsIco} />
                </i>{" "}
                NodeJS
              </li>
              <li>
                <i>
                  <img alt="image" src={tsIco} />
                </i>{" "}
                Typescript
              </li>
              <li>
                <i>
                  <img alt="image" src={nestIco} />
                </i>{" "}
                NestJS
              </li>
              <li>
                <i>
                  <img alt="image" src={firebaseIco} />
                </i>{" "}
                Firebase
              </li>
              <li>
                <i>
                  <img
                    alt="image"
                    src={restIco}
                    style={{ filter: "invert()" }}
                  />
                </i>{" "}
                Rest API
              </li>
            </ul>
            <footer className="skill-item-title">
              Backend <span style={{ color: "#51cda0" }}>26.7%</span>{" "}
            </footer>
          </div>

          {/* Database */}
          <div className="skill-item">
            <ul className="skill-item-list">
              <li>
                <i>
                  <img alt="image" src={mongoIco} />
                </i>{" "}
                MongoDB
              </li>
              <li>
                <i>
                  <img alt="image" src={oracleIco} />
                </i>{" "}
                Oracle
              </li>
              <li>
                <i>
                  <img
                    alt="image"
                    src={mySqlIco}
                    style={{
                      filter: "saturate(255%) brightness(120%)",
                    }}
                  />
                </i>{" "}
                MySQL
              </li>
              <li>
                <i>
                  <img
                    alt="image"
                    src={sqLiteIco}
                    style={{
                      filter: "contrast(35%) saturate(245%) brightness(130%)",
                    }}
                  />
                </i>{" "}
                SQLite
              </li>
            </ul>
            <footer className="skill-item-title">
              Database <span style={{ color: "#df7970" }}>26.7%</span>{" "}
            </footer>
          </div>

          {/* Extra */}
          <div className="skill-item">
            <ul className="skill-item-list">
              <li>
                <i>
                  <img
                    alt="image"
                    src={canvasJSIco}
                    style={{ filter: "saturate(120%)" }}
                  />
                </i>{" "}
                CanvasJS (chart)
              </li>
              <li>
                <i>
                  <img
                    alt="image"
                    src={phpIco}
                    style={{ filter: "saturate(219%)" }}
                  />
                </i>{" "}
                PHP (MVC)
              </li>
              <li>
                <i>
                  <img alt="image" src={pythonIco} />
                </i>{" "}
                Python
              </li>
              <li>
                <i>
                  <img
                    alt="image"
                    src={javaIco}
                    style={{
                      filter: "saturate(519%) brightness(267%) contrast(68%)",
                    }}
                  />
                </i>{" "}
                JAVA
              </li>
            </ul>
            <footer className="skill-item-title">
              Extra <span style={{ color: "#4c9ca0" }}>13.3%</span>{" "}
            </footer>
          </div>
        </div>
      </>
    ),
  },
};

/* FRENCH */
export const developerCompFrenchData: HomeMainCompProps = {
  homeMainCompData: {
    label: "developer",
    title: "DEVELOPPEUR",
    subtitle: "En tant que",
    img: coverImage,
    text: "Mes technologies préférées sont <split/>MEAN<split/> et <split/>MERN",
    button: [],
    imgList: [],

    children: (
      <>
        <div className="skill-list">
          {/* Frontend */}
          <div className="skill-item">
            <ul className="skill-item-list">
              <li>
                <i>
                  <img alt="image" src={angularIco} />
                </i>{" "}
                Angular + Ngrx{" "}
                <i>
                  <img
                    alt="image"
                    src={ngrxIco}
                    style={{
                      filter: "contrast(90%) saturate(75%) brightness(130%)",
                    }}
                  />
                </i>
              </li>
              <li>
                <i>
                  <img alt="image" src={reactIco} />
                </i>{" "}
                React + Redux{" "}
                <i>
                  <img
                    alt="image"
                    src={reduxIco}
                    style={{
                      filter: "contrast(80%) saturate(155%)",
                    }}
                  />
                </i>
              </li>
              <li>
                <i>
                  <img
                    alt="image"
                    src={bootstrapIco}
                    style={{
                      filter: "contrast(80%) saturate(355%) brightness(120%)",
                    }}
                  />
                </i>{" "}
                Bootstrap
              </li>
              <li>
                <i>
                  <img alt="image" src={ionicIco} />
                </i>{" "}
                Ionic
              </li>
              <li>
                <i>
                  <img
                    alt="image"
                    src={jsIco}
                    style={{ filter: "saturate(120%)" }}
                  />
                </i>{" "}
                Javascript
              </li>
            </ul>
            <footer className="skill-item-title">
              Frontend <span style={{ color: "#6d78ad" }}>33.3%</span>{" "}
            </footer>
          </div>

          {/* Backend */}
          <div className="skill-item">
            <ul className="skill-item-list">
              <li>
                <i>
                  <img alt="image" src={nodeJsIco} />
                </i>{" "}
                NodeJS
              </li>
              <li>
                <i>
                  <img alt="image" src={tsIco} />
                </i>{" "}
                Typescript
              </li>
              <li>
                <i>
                  <img alt="image" src={nestIco} />
                </i>{" "}
                NestJS
              </li>
              <li>
                <i>
                  <img alt="image" src={firebaseIco} />
                </i>{" "}
                Firebase
              </li>
              <li>
                <i>
                  <img
                    alt="image"
                    src={restIco}
                    style={{ filter: "invert()" }}
                  />
                </i>{" "}
                Rest API
              </li>
            </ul>
            <footer className="skill-item-title">
              Backend <span style={{ color: "#51cda0" }}>26.7%</span>{" "}
            </footer>
          </div>

          {/* Database */}
          <div className="skill-item">
            <ul className="skill-item-list">
              <li>
                <i>
                  <img alt="image" src={mongoIco} />
                </i>{" "}
                MongoDB
              </li>
              <li>
                <i>
                  <img alt="image" src={oracleIco} />
                </i>{" "}
                Oracle
              </li>
              <li>
                <i>
                  <img
                    alt="image"
                    src={mySqlIco}
                    style={{
                      filter: "saturate(255%) brightness(120%)",
                    }}
                  />
                </i>{" "}
                MySQL
              </li>
              <li>
                <i>
                  <img
                    alt="image"
                    src={sqLiteIco}
                    style={{
                      filter: "contrast(35%) saturate(245%) brightness(130%)",
                    }}
                  />
                </i>{" "}
                SQLite
              </li>
            </ul>
            <footer className="skill-item-title">
              Database <span style={{ color: "#df7970" }}>26.7%</span>{" "}
            </footer>
          </div>

          {/* Extra */}
          <div className="skill-item">
            <ul className="skill-item-list">
              <li>
                <i>
                  <img
                    alt="image"
                    src={canvasJSIco}
                    style={{ filter: "saturate(120%)" }}
                  />
                </i>{" "}
                CanvasJS (chart)
              </li>
              <li>
                <i>
                  <img
                    alt="image"
                    src={phpIco}
                    style={{ filter: "saturate(219%)" }}
                  />
                </i>{" "}
                PHP (MVC)
              </li>
              <li>
                <i>
                  <img alt="image" src={pythonIco} />
                </i>{" "}
                Python
              </li>
              <li>
                <i>
                  <img
                    alt="image"
                    src={javaIco}
                    style={{
                      filter: "saturate(519%) brightness(267%) contrast(68%)",
                    }}
                  />
                </i>{" "}
                JAVA
              </li>
            </ul>
            <footer className="skill-item-title">
              Extra <span style={{ color: "#4c9ca0" }}>13.3%</span>{" "}
            </footer>
          </div>
        </div>
      </>
    ),
  },
};
